import React, { useEffect, useState, useRef } from "react";
import { useMediaQuery } from "react-responsive";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectFade, Autoplay, Pagination, Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";
import "swiper/css/navigation";
import style from "css/landing.module.css";
import { Link } from "react-router-dom";

function Visual() {
  const isMobile = useMediaQuery({ query: "(max-width: 767px)" });
  const isTablet = useMediaQuery({
    query: "(min-width: 768px) and (max-width: 1024px)",
  });

  const swiperRef = useRef(null);
  const imgRef = useRef(null);
  const paginationRef = useRef(null);
  const prevRef = useRef(null);
  const nextRef = useRef(null);

  const [progressTop, setProgressTop] = useState("unset");
  const [autoplayProgress, setAutoplayProgress] = useState(0);

  const visualList = [
    {
      img: "img/landing/visual/visual_1.png",
      type: "reference",
      title: "크래프톤 서울 본사",
      description:
        "대형 회의실 · 중형 회의실 · 소형 회의실까지\nNeat Bar Pro · Neat Center · Neat Pad를 유기적으로 연동하여 하이브리드 협업 환경을 구축했습니다.",
      link: "https://www.instagram.com/p/DVQQoFCD_9N/?img_index=1",
    },
    {
      img: "img/landing/visual/visual_2.png",
      type: "reference",
      title: "국립암센터",
      description:
        "국립암센터의 국제회의장과 검진동 대강의실에\n대형 LED 디스플레이 시스템을 구축하여\n행사 · 교육 · 컨퍼런스 환경의 품격을 높였습니다.",
      link: "",
    },
    {
      img: "img/landing/visual/visual_3.png",
      type: "solution",
      solution: "allplace",
      title: "하나의 플랫폼으로\n공간 운영을 더 효율적으로,\nall Place",
      description:
        !isMobile && !isTablet
          ? "회의실 예약 · 좌석예약 · 화상회의 예약 · 월 패드 · 전자명패 · 화상장비까지\n유연한 업무공간을 위한 스마트예약시스템"
          : "회의실 예약 · 좌석예약 · 화상회의 예약 · 월 패드 · 전자명패 · 화상장비까지 유연한 업무공간을 위한 스마트예약시스템",
    },
    {
      img: "img/landing/visual/visual_4.png",
      type: "solution",
      solution: "telehealth",
      title:
        !isMobile && !isTablet
          ? "독자적인 기술력과 검증된 품질,\n텔레헬스 환경을 안정적으로\n구현하세요."
          : "독자적인 기술력과\n검증된 품질, 텔레헬스 환경을 안정적으로 구현하세요.",

      description:
        !isMobile && !isTablet
          ? "병원 EMR 연동, Zoom 기반화상회진, 보호자 참여와\n병원 현장에 맞춘 리브테크놀로지의 원격 화상협진 플랫폼까지"
          : "병원 EMR 연동, Zoom 기반화상회진, 보호자 참여와 병원 현장에 맞춘\n리브테크놀로지의 원격 화상협진 플랫폼까지",
    },
  ];

  const handlePrev = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slidePrev();
    }
  };

  const handleNext = () => {
    if (swiperRef.current && swiperRef.current.swiper) {
      swiperRef.current.swiper.slideNext();
    }
  };

  const updatePosition = () => {
    if (!imgRef.current) return;

    const imgTop = imgRef.current.offsetTop; // 이미지 top 위치 [web:3][cite:16]
    const imgHeight = imgRef.current.offsetHeight; // 이미지 높이
    const bottom = imgTop + imgHeight; // 이미지 하단 위치

    setProgressTop(`${bottom + 15}px`); // 하단 + 15px
  };

  useEffect(() => {
    updatePosition();

    window.addEventListener("resize", updatePosition);
    window.addEventListener("scroll", updatePosition);

    // Swiper 슬라이드 변경 시에도 업데이트 (Swiper 컨텍스트에서)
    const handleSlideChange = () => updatePosition();
    swiperRef.current?.swiper?.on("slideChange", handleSlideChange); // 필요시

    return () => {
      window.removeEventListener("resize", updatePosition);
      window.removeEventListener("scroll", updatePosition);
    };
  }, [isMobile, isTablet]);

  return (
    <div className={style.visual_wrap}>
      <Swiper
        ref={swiperRef}
        slidesPerView={"auto"}
        effect={"fade"}
        fadeEffect={{ crossFade: true }}
        modules={[EffectFade, Autoplay, Pagination, Navigation]}
        loop={true}
        autoplay={{
          delay: 5000,
          disableOnInteraction: false,
        }}
        className={style.visual_list_wrap}
        observer={true}
        observeParents={true}
        observeSlideChildren={true}
        speed={400}
        grabCursor={false}
        pagination={{
          el: paginationRef.current,
          type: "custom",
          // renderCustom: (swiper, current, total) => {
          //   const progress = (current / total) * 100;
          //   return `
          //   <div class="${style.progress_wrap}">
          //       <div class="${style.progress_current}">${current}</div>
          //       <div class="${style.progress_bar}">
          //           <span class="${style.progress_fill}" style="width:${progress}%"></span>
          //       </div>
          //       <div class="${style.progress_total}">${total}</div>
          //   </div>
          // `;
          // },
          renderCustom: (swiper, current, total) => {
            const percent = autoplayProgress * 100; // 0~100
            return `
              <div class="${style.progress_wrap}">
                <div class="${style.progress_current}">${current}</div>
                <div class="${style.progress_bar}">
                  <span class="${style.progress_fill}" style="width:${percent}%"></span>
                </div>
                <div class="${style.progress_total}">${total}</div>
              </div>
            `;
          },
        }}
        onBeforeInit={(swiper) => {
          swiper.params.pagination.el = paginationRef.current;
        }}
        onAutoplayTimeLeft={(_, timeLeft, progress) => {
          // progress: 0 ~ 1 (경과 비율, 1이면 다음 슬라이드 직전)
          // timeLeft: 남은 ms (delay 5000 기준 0~5000)
          setAutoplayProgress(1 - progress); // 0에서 시작해 1까지 채우고 싶으면 반전
        }}
      >
        {visualList.map((item, index) => (
          <SwiperSlide
            className={style.visual_item}
            key={index}
          >
            <div className={style.visual_item_contens_wrap}>
              {item.type === "reference" ? (
                <div className={style.visual_item_label}>
                  리브테크놀로지 <span>도입 사례</span>
                </div>
              ) : item.type === "solution" &&
                item?.solution === "allplace" &&
                !isMobile &&
                !isTablet ? (
                <img
                  className={style.saas_open_img}
                  src={`${process.env.REACT_APP_CLIENT_URL}img/landing/visual/saas_open.png`}
                  alt=""
                />
              ) : (
                <></>
              )}
              <div className={style.visual_item_title_wrap}>
                <div className={style.visual_item_title}>{item.title}</div>
                <div className={style.visual_item_description}>
                  {item.description}
                </div>
              </div>
              {item.type === "reference" ? (
                <button
                  className={style.visual_item_link_btn}
                  onClick={() =>
                    window.open(
                      item.link === ""
                        ? "https://www.instagram.com/rivtechnology/"
                        : item.link,
                      "_blank",
                    )
                  }
                >
                  <span>
                    {item.link === "" ? "더 많은 사례 보기" : "사례 자세히보기"}
                  </span>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/common/right.png`}
                    alt=""
                  />
                </button>
              ) : item.type === "solution" && item?.solution === "allplace" ? (
                <div className={style.visual_item_link_btn_group}>
                  <Link
                    className={`${style.visual_item_link_btn} ${style.blue}`}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/allplace`}
                  >
                    <img
                      className={style.new_icon}
                      src={`${process.env.REACT_APP_CLIENT_URL}img/landing/visual/${!isMobile && !isTablet ? `new` : `new_m`}.png`}
                      alt=""
                    />
                    <span>구독형</span>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/common/right.png`}
                      alt=""
                    />
                  </Link>
                  <Link
                    className={`${style.visual_item_link_btn}`}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/allplace`}
                  >
                    <span>구축형</span>
                    <img
                      src={`${process.env.REACT_APP_CLIENT_URL}img/common/right.png`}
                      alt=""
                    />
                  </Link>
                </div>
              ) : item.type === "solution" &&
                item?.solution === "telehealth" ? (
                <Link
                  className={`${style.visual_item_link_btn}`}
                  to={`${process.env.REACT_APP_CLIENT_URL}smart-space/telehealth`}
                >
                  <span>텔레헬스 시스템 보기</span>
                  <img
                    src={`${process.env.REACT_APP_CLIENT_URL}img/common/right.png`}
                    alt=""
                  />
                </Link>
              ) : (
                <></>
              )}
            </div>
            <div
              className={style.visual_item_img}
              ref={imgRef}
            >
              {item.type === "solution" &&
              item?.solution === "allplace" &&
              (isMobile || isTablet) ? (
                <img
                  className={style.saas_open_img}
                  src={`${process.env.REACT_APP_CLIENT_URL}img/landing/visual/saas_open_m.png`}
                  alt=""
                />
              ) : null}
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}` + item.img}
                alt=""
              />
            </div>
          </SwiperSlide>
        ))}

        <div
          className={style.visual_progress_wrap}
          style={{ top: isMobile || isTablet ? progressTop : "unset" }}
        >
          <div
            ref={paginationRef}
            className={style.visual_progress}
          />
          <div className={style.visual_nav_btn_group}>
            <button
              ref={prevRef}
              type="button"
              className={style.visual_nav_btn}
              onClick={handlePrev}
              aria-label="이전"
            >
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/common/arrow_left.png`}
                alt=""
              />
            </button>
            <button
              ref={nextRef}
              type="button"
              className={style.visual_nav_btn}
              onClick={handleNext}
              aria-label="다음"
            >
              <img
                src={`${process.env.REACT_APP_CLIENT_URL}img/common/arrow_right.png`}
                alt=""
              />
            </button>
          </div>
        </div>
      </Swiper>
    </div>
  );
}

export default Visual;
